// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CodeGraphNodeCategorySchema } from '../inputTypeSchemas/CodeGraphNodeCategorySchema'

/////////////////////////////////////////
// CODE GRAPH NODE SCHEMA
/////////////////////////////////////////

export const CodeGraphNodeSchema = z.object({
  type: CodeGraphNodeCategorySchema,
  id: z.string(),
  name: z.string(),
  filePath: z.string(),
  startLine: z.number().int().nullable(),
  endLine: z.number().int().nullable(),
  repositoryName: z.string(),
})

export type CodeGraphNode = z.infer<typeof CodeGraphNodeSchema>

export default CodeGraphNodeSchema;
